import { LabDataItem } from "../Types/LabData";
import {
    Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Paper, Typography, useTheme,
} from "@mui/material";

function LabDataSubTable({ labData }: { labData?: LabDataItem[] }) {
    const theme = useTheme();
    const mutedBlue = theme.palette.secondary.main; // Muted blue color from theme
    // If no data is available, display a message
    if (!labData || labData.length === 0) {
        return <Typography variant="body2">No lab data available</Typography>;
    }

    // Sort data by date in descending order (newest first)
    const sortedData = [...labData].sort((a, b) =>
        new Date(b.dateSampled).getTime() - new Date(a.dateSampled).getTime()
    );

    return (
        <TableContainer
            component={Paper}
            sx={{
                maxHeight: 400,
                width: '100%',
                marginTop: 2,
                marginBottom: 2,
                borderRadius: 1,
                overflow: 'hidden'
            }}
        >
            <Table stickyHeader aria-label="lab data table" size="small">
                <TableHead>
                    <TableRow sx={{ backgroundColor: 'rgba(94, 129, 172, 0.2)' }}>
                        <TableCell sx={{ fontWeight: 'bold', color: mutedBlue }}>Date Sampled</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: mutedBlue }}>Glucose</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: mutedBlue }}>Sucrose</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: mutedBlue }}>Gravity</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedData.map((item, index) => (
                        <TableRow
                            key={index}
                            hover
                            sx={{
                                '&:nth-of-type(odd)': { backgroundColor: 'rgba(94, 129, 172, 0.08)' },
                                '&:hover': {
                                    backgroundColor: 'rgba(94, 129, 172, 0.25)',
                                    transition: 'background-color 0.2s ease'
                                }
                            }}
                        >
                            <TableCell>{new Date(item.dateSampled).toLocaleDateString(undefined, {
                                month: '2-digit',
                                day: '2-digit',
                                year: '2-digit',
                                timeZone: 'UTC'
                            })}</TableCell> 
                            <TableCell>{item.glucose}</TableCell>
                            <TableCell>{item.sucrose}</TableCell>
                            <TableCell>{item.gravity}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default LabDataSubTable;